import { render, staticRenderFns } from "./MosaicoBeneficios.vue?vue&type=template&id=a23f536c&scoped=true&lang=pug"
import script from "./MosaicoBeneficios.vue?vue&type=script&lang=js"
export * from "./MosaicoBeneficios.vue?vue&type=script&lang=js"
import style0 from "./MosaicoBeneficios.styl?vue&type=style&index=0&id=a23f536c&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23f536c",
  null
  
)

export default component.exports